
import Vue from "vue";
import { FIcon } from "@fkui/vue";
import { ElementIdService } from "@fkui/logic";

type IconName = "doc" | "file" | "pic" | "pdf";

/* default icon used when no mimetype matches */
const DEFAULT_ICON: IconName = "file";

/* map mimetype -> icon */
const iconMap: Record<string, IconName> = {
    "image/*": "pic",
    "application/msword": "doc",
    "application/pdf": "pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template": "doc",
};

export default Vue.extend({
    name: "TextFileItem",
    components: { FIcon },
    props: {
        /**
         * The id for the input id attribute.
         * The id for the label for attribute.
         * If the prop is not set a random value will be generated.
         */
        id: {
            type: String,
            required: false,
            default: () => ElementIdService.generateElementId(),
        },
        /**
         * The file name.
         */
        fileName: {
            type: String,
            required: true,
        },
        /**
         * The mime type, can be changed if i.e server change the name.
         */
        mimeType: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    computed: {
        attrs(): Record<string, string> {
            return {
                target: "_blank",
                ...this.$attrs,
                id: this.id,
            };
        },
        iconName(): IconName {
            const { mimeType } = this;

            /* use default icon when mimetype is empty/missing */
            if (!mimeType) {
                return DEFAULT_ICON;
            }

            /* search literal match */
            if (iconMap[mimeType]) {
                return iconMap[mimeType];
            }

            /* search with subtype wildcard, e.g. image/* */
            const p = mimeType.split("/", 1);
            const wildcard = [p[0], "*"].join("/");
            if (iconMap[wildcard]) {
                return iconMap[wildcard];
            }

            /* default to file */
            return DEFAULT_ICON;
        },
    },
});
